module.exports = __webpack_public_path__ + "static/media/waitlist-member-5.5eb1c9dc.jpeg";